import { render, staticRenderFns } from "./MyProfileView.vue?vue&type=template&id=273b142a&lang=pug"
import script from "./MyProfileView.vue?vue&type=script&lang=js"
export * from "./MyProfileView.vue?vue&type=script&lang=js"
import style0 from "./MyProfileView.vue?vue&type=style&index=0&id=273b142a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports